import { User } from './models/user';
import { UserService } from './services/user.service';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';

import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { from, Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, take } from 'rxjs/operators';
import { ActivityType } from './models/ActivityType';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { AuthService } from '@auth0/auth0-angular';
import { DeniedDialogComponent } from './glp-common/components/denied-dialog/denied-dialog.component';
import { TelementryService } from './services/telemetry.service';
import * as Sentry from "@sentry/angular";
import { getPortalVersion, PortalVersion } from './portal-config';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {

  title = 'group-leader-portal-ui';
  subscriptions: Subscription[] = [];
  loggedIn = false;
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private telementryService: TelementryService,
    public auth: AuthService,
  )
  {
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
 
  ngOnInit() {
    if(document.URL.includes('/register') || document.URL.includes('/recertify')){
      let urlParams = new URLSearchParams(window.location.search)
      let callbackURL = urlParams.get('callback');

      if(callbackURL && callbackURL.length > 0){
        sessionStorage.setItem('sapURL', callbackURL);
      }
    }

    sessionStorage.setItem('preAuthPath', location.pathname.toLowerCase());
    
    this.auth.isAuthenticated$.pipe(distinctUntilChanged())
    .subscribe((authResult) => {
      if(!authResult){
        if((document.URL.includes('/register') || document.URL.includes('/recertify')) && sessionStorage.getItem('sapURL')){    
          if(!sessionStorage.getItem('sapURL').includes(environment['sapDomain'])){
            alert('Invalid SAP onboarding case provided. Please reach out to your agency for more information.');
            sessionStorage.removeItem('sapURL');
            this.router.navigate(['/']);
          }
          else{
            if(document.URL.includes('/register')){
              sessionStorage.setItem('brokerNeedsForm', 'true');
              this.router.navigate(['/register']);
            }
            else if(document.URL.includes('/recertify')){
              this.router.navigate(['/register']);
            }
          }
        }
        else{
          sessionStorage.setItem('loggedIn', 'true');
          this.auth.loginWithRedirect();
        }
      }
      else if (authResult) {
        this.auth.user$.pipe(take(1)).subscribe((account) => {

          if(sessionStorage.getItem('loggedIn') != 'true'){
            let logoutUrl = getPortalVersion() == PortalVersion.EOA ? environment.redirectUrlGL : environment.redirectUrlBroker;
            this.auth.logout({ logoutParams: { returnTo: logoutUrl } });
            return;
          }

          var destinationRoute ='/not-approved';

          if (account) {
            this.userService
              .generateUserFromAccount(account)
              .subscribe(() => { 

                let userPath = sessionStorage.getItem('preAuthPath') ?? location.pathname.toLowerCase();
                sessionStorage.removeItem('preAuthPath');

                
                if(userPath == '/logout'){
                  this.router.navigate([userPath]);
                  return;
                }

                var maintenancemode = environment['MaintenanceMode']; 
                if(maintenancemode){
                  if(account.is_Broker && account.is_Activated){
                    destinationRoute = '/home/maintenanceModeBroker';
                  }
                  else if(account.is_group_leader){
                    destinationRoute = '/home/maintenanceModeGL';
                  }
                }
                else if(sessionStorage.getItem('sapURL')){
                  destinationRoute = '/completeRegistration';
                }
                else if(!this.userService.isGroupLeaderUser() && getPortalVersion() == PortalVersion.EOA){
                  sessionStorage.setItem('groupleaderNeedsForm', 'true');
                  destinationRoute = '/completeRegistration';
                }
                else if(account.is_Broker && account.is_Activated){
                  let validEndpoints = [
                    '/home/contact',
                    '/home/maapplicationstatus'
                  ];
                  destinationRoute = validEndpoints.includes(userPath) ? userPath : '/home/broker'; 
                }
                else if(account.is_group_leader ){
                    destinationRoute = '/home/GroupLeaderAccounts';
                }

                Sentry.setUser({
                  email: account.email,
                  username: account.name,
                });

                this.loggedIn = true;
                this.telementryService.trackActivity(ActivityType.SignIn, `email: ${account.email}, destinationroute ${destinationRoute}, isbroker: ${account.is_Broker}, isActivated ${account.is_Activated}`, 3)

                this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
                    this.router.navigate([destinationRoute]);
                }); 
              },
              (error) => { 
                this.loggedIn = true;
                this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
                  this.router.navigate(['/not-approved']);
                }); 
              } 
            );
          }
        });

      }
    }); 
  }
}
